module.exports = __webpack_public_path__ + "img/code reviews for contractors 960x360.a2eb8bb0.jpg";